import { AxiosResponse } from 'axios'
import ApiService, { IRequestParameters } from '@/plugins/api-plugin/services/api.service'
import {
    CreditNoteDetailDao,
    CreditNoteDraftDao,
    CreditNoteLookupsDao,
    CreditNoteSearchRowDao,
} from '@/interfaces/credit-note/CreditNote.dao'
import {
    AddCreditNoteCommentDto,
    ChangeCreditNoteStatusDto,
    CreateCreditNoteDto,
} from '@/interfaces/credit-note/CreditNoteWrite.dto'
import { PageNumberPagination } from '@/interfaces/common/PageNumberPagination'

export default class CreditNotesService extends ApiService {
    async searchCreditNotes(
        params?: IRequestParameters,
    ): Promise<[CreditNoteSearchRowDao[], PageNumberPagination] | null> {
        return this.request<undefined, [CreditNoteSearchRowDao[], PageNumberPagination] | null>(
            'GET',
            '/credit-notes',
            params,
            undefined,
            undefined,
            'searchCreditNotes',
        ).catch(() => null)
    }

    async getCreditNoteLookups(): Promise<CreditNoteLookupsDao | null> {
        return this.request<undefined, CreditNoteLookupsDao>(
            'GET',
            '/credit-notes/lookups',
            undefined,
            undefined,
            undefined,
            'getCreditNoteLookups',
        ).catch(() => null)
    }

    async getCreditNote(id: number): Promise<CreditNoteDetailDao | null> {
        return this.request<undefined, CreditNoteDetailDao>(
            'GET',
            `/credit-notes/${id}`,
            undefined,
            undefined,
            undefined,
            'getCreditNote',
        ).catch(() => null)
    }

    async getCreditNoteDraft(orderId: number): Promise<CreditNoteDraftDao | null> {
        return this.request<undefined, CreditNoteDraftDao>(
            'GET',
            '/credit-notes/draft',
            { orderId },
            undefined,
            undefined,
            'getCreditNoteDraft',
        ).catch(() => null)
    }

    async createCreditNote(dto: CreateCreditNoteDto): Promise<CreditNoteDetailDao | null> {
        return this.request<CreateCreditNoteDto, CreditNoteDetailDao>(
            'POST',
            '/credit-notes',
            undefined,
            dto,
            undefined,
            'createCreditNote',
        ).catch(() => null)
    }

    async exportCreditNotes(params: IRequestParameters): Promise<AxiosResponse | null> {
        return this.request<undefined, AxiosResponse>(
            'POST',
            '/credit-notes/export',
            params,
            undefined,
            'blob',
            'exportCreditNotes',
        ).catch(() => null)
    }

    async updateCreditNote(id: number, dto: CreateCreditNoteDto): Promise<CreditNoteDetailDao | null> {
        return this.request<CreateCreditNoteDto, CreditNoteDetailDao>(
            'PUT',
            `/credit-notes/${id}`,
            undefined,
            dto,
            undefined,
            'updateCreditNote',
        ).catch(() => null)
    }

    async releaseCreditNoteForExport(id: number): Promise<CreditNoteDetailDao | null> {
        return this.request<undefined, CreditNoteDetailDao>(
            'POST',
            `/credit-notes/${id}/release-for-export`,
            undefined,
            undefined,
            undefined,
            'releaseCreditNoteForExport',
        ).catch(() => null)
    }

    async changeCreditNoteStatus(id: number, dto: ChangeCreditNoteStatusDto): Promise<CreditNoteDetailDao | null> {
        return this.request<ChangeCreditNoteStatusDto, CreditNoteDetailDao>(
            'PATCH',
            `/credit-notes/${id}/status`,
            undefined,
            dto,
            undefined,
            'changeCreditNoteStatus',
        ).catch(() => null)
    }

    async addCreditNoteComment(id: number, dto: AddCreditNoteCommentDto): Promise<CreditNoteDetailDao | null> {
        return this.request<AddCreditNoteCommentDto, CreditNoteDetailDao>(
            'POST',
            `/credit-notes/${id}/comments`,
            undefined,
            dto,
            undefined,
            'addCreditNoteComment',
        ).catch(() => null)
    }
}
